import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import CircleProgressBar from "../../Components/ProgressBar/CircleProgressBar";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "#F5F7FF",
  border: "2px solid #FFFFFF",
  borderRadius: 10,
  p: 4,
};

const BookModal = (props) => {
  return (
    <div>
      <Modal
        open={props.visible}
        onClose={() => {
          if (!props.persistent) {
            props.toggleModal(false);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: "0px !important" }}
      >
        <Box
          sx={{
            ...style,
            backgroundColor: "#FFFFFF",
            border: 0,
            borderRadius: 6,
          }}
        >
          <Grid
            container
            sx={{
              flexDirection: "row",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              px: 5,
            }}
          >
            {props.progressVal && (
              <>
                <Grid item sx={{ justifyContent: "center" }}>
                  <CircleProgressBar circleVal={props.progressVal} />
                </Grid>
                <Typography
                  id="modal-modal-title"
                  sx={{
                    color: "primary.main",
                    fontSize: "1.4rem",
                    fontWeight: "800",
                    textAlign: "center",
                    mt: 3
                  }}
                >
                  {props.primaryText}
                </Typography>
              </>
            )}
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default BookModal;
